

 
<div class="chart-container">
    
    <mat-card>
    

      <div class="chart-width">

      <canvas id="chartFbJeTp"></canvas>
      </div>
    </mat-card>
  </div>
  